import { render, staticRenderFns } from "./TechniciansCatalog.vue?vue&type=template&id=67e57dbe"
import script from "./TechniciansCatalog.vue?vue&type=script&lang=ts"
export * from "./TechniciansCatalog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports